<template>
    <div>
        <v-card class="pl-2 pr-2">
            <v-row>
                <v-select
                        class="ml-3 mr-3"
                        :items="earningsPeriods"
                        :label="$tc('Period')"
                        :item-text="'name'"
                        :item-value="'value'"
                        v-model="selectedEarningsPeriod"
                        v-on:change="loadTableData()"
                        outlined
                        :disabled="!useEarningsPeriod"
                ></v-select>
            </v-row>

            <FromToDateFilter :disabled="useEarningsPeriod"/>

            <v-row>
                <v-col>
                    <v-btn small
                           center
                           @click="toggleUseEarningsPeriod()">
                        {{ userEarningsPeriodToggleButtonPhrase }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-data-table
                :headers="headers"
                :items="tableData.rows"
                :loading="tableDataIsLoading"
                class="elevation-1"
                item-key="pk"
                hide-default-footer
                mobile-breakpoint="0"
        >
            <template v-slot:item.total_amount="{ item }">
                <span>{{ formatValue(item.total_amount) || 0 }}</span>
            </template>

            <template v-slot:body.append>
                <tr class="font-weight-bold"
                    v-if="canShowFooter"
                >
                    <td>{{ $t('Total') }}</td>
                    <td> {{ tableData.sum_row.total_number_of_tickets_sold }} </td>
                    <td>{{ formatValue(tableData.sum_row.all_rows_total_amount) }}</td>
                    <td>{{ tableData.rows[0].currency__code }}</td>
                </tr>
            </template>
        </v-data-table>

    </div>
</template>

<script>
    import i18n from "@/i18n";
    import {mapGetters, mapState} from "vuex";
    import axios from "axios";
    import FromToDateFilter from "@/components/FromToDateFilter";
    import FormatHelper from "../core/helpers/format-helper";

    export default {
        name: "InternalStatisticsView",
        components: {FromToDateFilter},
        mounted() {
            if (this.isAuthenticated) {
                this.loadAllData();
            }
        },
        data: () => ({
            tableDataIsLoading: true,
            headers:
                [
                    {
                        text: i18n.t('Area'),
                        value: 'name',
                    },
                    {
                        text: i18n.t('NumberOfSoldTickets'),
                        value: 'number_of_tickets_sold',
                    },
                    {
                        text: i18n.t('Amount'),
                        value: 'total_amount',
                    },
                    {
                        text: i18n.t('CurrencyCode'),
                        value: 'currency__code',
                    },
                ],
            tableData: [],
            selectedEarningsPeriod: 1,
            useEarningsPeriod: true,
        }),
        computed: {
            ...mapGetters('common', [
                'serverURL',
                'earningsPeriods',
            ]),
            ...mapGetters('auth', [
                'isAuthenticated',
            ]),
            ...mapState('common', [
                'selectedFromDate',
                'selectedToDate',
            ]),
            ...mapState('auth', [
                'userIsSuperUser',
            ]),
            canShowFooter: function () {
                return this.tableData !== undefined
                    && this.tableData.rows !== undefined
                    && this.tableData.rows.length > 0;
            },
            userEarningsPeriodToggleButtonPhrase: function () {
                if (this.useEarningsPeriod) {
                    return i18n.tc('UseCustomDate', 3);
                }
                else {
                    return i18n.t('UsePeriod');
                }
            },
        },
        watch: {
            isAuthenticated() {
                this.loadAllData();
            },
            selectedFromDate() {
                this.useEarningsPeriod = false;
                this.loadAllData();
            },
            selectedToDate() {
                this.useEarningsPeriod = false;
                this.loadAllData();
            },
        },
        methods: {
            loadAllData() {
                if (this.userIsSuperUser) {
                    this.loadTableData();
                }
                else {
                    this.tableData = [];
                }
            },
            loadTableData() {
                this.tableDataIsLoading = true;

                let earningsPeriodRequestParameter = null;

                if (this.useEarningsPeriod) {
                    earningsPeriodRequestParameter = this.selectedEarningsPeriod;
                }
                axios
                    .get(this.serverURL + '/get_internal_area_statistics/', {
                        params: {
                            from_date: this.selectedFromDate,
                            to_date: this.selectedToDate,
                            quick_statistics_period: earningsPeriodRequestParameter,
                        }
                    })
                    .then(response => {
                        this.tableData = response.data;
                        this.tableDataIsLoading = false;
                    })
                    .catch(() => {
                        this.tableDataIsLoading = false;
                    });
            },
            toggleUseEarningsPeriod()  {
                this.useEarningsPeriod = !this.useEarningsPeriod;
                this.loadTableData();
            },
            formatValue(value_to_format) {
                return FormatHelper.formatValueWithNoDecimals(value_to_format);
            }
        }
    }
</script>

<style scoped>

</style>